import * as React from "react";
import { Helmet } from "react-helmet";

// Presentation/UI
import styled from "styled-components";

import { Col, Row, Table } from "reactstrap";
import Card from "../../Components/Styled/Card";
import { Colors } from "src/Themes";
import { Query } from "react-apollo";
import gql from "graphql-tag";
import { dashboardCount } from "../../graphql/custom-queries";
import PageLoader from "src/Components/PageLoader";

import StackedBarChart from "../../Components/Charts/StackedBarChart";
import SimpleLineChart from "../../Components/Charts/SimpleLineChart";

import { purchaseData, newClientsData } from "../../Utils/Consts";

class Dashboard extends React.Component<{}> {
  showCountCard = (name: string, count: number) => {
    return (
      <Col md={4}>
        <Card color={Colors.default}>
          <h5 className="text-white">{name}</h5>
          <h3 className="text-white">{count}</h3>
        </Card>
      </Col>
    );
  };
  render() {
    return (
      <BackendWrapper>
        <Query query={gql(dashboardCount)}>
          {({ loading, error, data }) => {
            if (loading) {
              return <PageLoader />;
            }
            if (data) {
              return (
                <Row>
                  {this.showCountCard(
                    "Clients",
                    data.listCompanys.items.length
                  )}
                  {this.showCountCard(
                    "Documents",
                    data.listReports.items.length
                  )}
                  {this.showCountCard(
                    "Purchased Documents",
                    data.listTransactions.items.length
                  )}
                </Row>
              );
            } else {
              return (
                <Row>
                  <p>There has been an error {error}</p>
                </Row>
              );
            }
          }}
        </Query>
        <Row style={{ paddingTop: "20px" }}>
          <Col md={6}>
            <Card>
              <Row>
                <Col>
                  <h6>Purchases</h6>
                </Col>
              </Row>
              <Row style={{ height: "400px" }}>
                <Col>
                  <StackedBarChart data={purchaseData} />
                </Col>
              </Row>
            </Card>
          </Col>
          <Col md={6}>
            <Card>
              <Row>
                <Col>
                  <h6>New Clients</h6>
                </Col>
              </Row>
              <Row style={{ height: "400px" }}>
                <SimpleLineChart data={newClientsData} />
              </Row>
            </Card>
          </Col>
        </Row>
        <Row style={{ paddingTop: "20px" }}>
          <Col md={6}>
            <h6>Top 10 Purchased Reports</h6>
          </Col>
          <Col md={6}>
            <p className="text-right">View all reports</p>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card width="100%">
              <Table>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Category</th>
                    <th>Last Updated</th>
                    <th>Purchases</th>
                    <th>Price</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">Document name</th>
                    <td>doc category</td>
                    <td>yesterday</td>
                    <td>20</td>
                    <td>R200</td>
                  </tr>
                </tbody>
              </Table>
            </Card>
          </Col>
        </Row>
        <Helmet title="Dashboard" />
      </BackendWrapper>
    );
  }
}

const BackendWrapper = styled.div`
  display: flex;
  flex: 1;
  background: ${Colors.dashboardGrey};
  min-height: 100vh;
  padding: 20px;
  flex-direction: column;
`;

export default Dashboard;



// WEBPACK FOOTER //
// ./src/Containers/Dashboard/index.tsx